import { CartModelProps } from '@/pages/checkout/cart'
import { IngressoModel } from '@/models/IngressoModel'

export function parseIngressosIds(ingressos: IngressoModel[]): number[] {
    return (ingressos ?? [])
        .filter((i) => i.ingresso_id == null)
        .map((i) => i.id as number)
}

const isAreaMesaOuAssento = (nomeclatura?: string) =>
    nomeclatura === 'mesa' || nomeclatura === 'assento'

export function validarCartMesaAssento(item: CartModelProps): { ok: boolean; message?: string } {
    if (!item.area || !isAreaMesaOuAssento(item.area.nomeclatura)) {
        return { ok: true }
    }

    const ids = parseIngressosIds(item.ingressos)
    if (ids.length === 0) {
        return { ok: false, message: 'Selecione ao menos uma mesa ou assento.' }
    }

    if (ids.length !== item.quantidade) {
        const tipo = item.area.nomeclatura ?? 'mesa'
        return {
            ok: false,
            message: `Carrinho incompleto: ${ids.length} ${tipo}(s) selecionada(s) para quantidade ${item.quantidade}. Volte ao evento e selecione novamente.`,
        }
    }

    return { ok: true }
}

export function validarTodosItensMesaAssento(dados: CartModelProps[]): { ok: boolean; message?: string } {
    for (const item of dados) {
        const r = validarCartMesaAssento(item)
        if (!r.ok) return r
    }
    return { ok: true }
}
